<template>
  <div class="environment position-relative">
    <MDBRow>
      <MDBCol class="position-relative">
        <div class="aspectContainer">
        </div>
        <img
          class="backstop position-absolute"
          src="@/assets/img/FullPlant.png"
          @click="zoomOut"
        />
        <div class="warmer" @click="warmer = false" v-show="warmer">
          <video autoplay muted>
            <source :src="pathToWarmer"/>
          </video>
        </div>
        <div
          v-if="getZoomState !== 'out' && pathToZoom('IN') && !skipZoom"
          class="backstop position-absolute"
          id="zoomIn"
          @click="zoomOut"
        >
          <VideoBackground
            class="backstop"
            :src="pathToZoom('IN')"
            :loop="false"
            preload="auto"
            @ready="ready"
            @playing="playing"
            @error="error"
            @loading="loading"
            @ended="zoomEnded"
          />
        </div>
        <div
          v-if="getZoomState === 'zoomout' && pathToZoom('OUT')"
          class="backstop position-absolute"
          id="zoomOut"
        >
          <VideoBackground
            class="backstop"
            :src="pathToZoom('OUT')"
            :loop="false"
            preload="auto"
            @ready="ready"
            @playing="playing"
            @error="error"
            @loading="loading"
            @ended="zoomEnded"
          />
        </div>
        <h1 class="main title" v-html="i18n.title('Landing')" v-if="!getNavShowing"/>
        <div
          class="hotspot position-absolute"
          v-for="hotspot in getHotspots"
          :key="hotspot.id"
          :style="position(hotspot)"
        >
          <MDBBtn
            class="hotspot"
            color="tertiary"
            v-if="getZoomState === 'out'"
            @click="click(hotspot.id)"
          >
            <img class="circle" src="@/assets/img/button-default.png"/>
          </MDBBtn>
        </div>
      </MDBCol>
    </MDBRow>
    <MDBModal
      :modelValue="getShowAnnotation"
      @hide="zoomOut"
      @update:modelValue="setShowAnnotation($event)"
    >
      <MDBModalHeader :closeWhite="true">
        <MDBModalTitle>{{ i18n.title(getAnnotation) }}</MDBModalTitle>
      </MDBModalHeader>
      <MDBModalBody>
        <Annotation
          :id="getAnnotation"
          @open-carousel="openCarousel"
          />
      </MDBModalBody>
    </MDBModal>
    <img class="logo" :class="{ accenture: plexConfig.accenture }" :src="pathToLogo"/>
    <img class="home" src="@/assets/img/icon-home.svg" @click="goHome"/>
    <MainNav @select="click"/>
  </div>
</template>

<script>
import { inject, ref, watch } from 'vue'
import { mapGetters, mapMutations, useStore } from 'vuex'

import { useIdle } from '@vueuse/core'

import {
  MDBBtn,
  MDBCol,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow
} from '@/index.pro.js'

import VideoBackground from 'vue-responsive-video-background-player'

import plexConfig from 'plexConfig'

import Annotation from '@/components/Annotation'
import MainNav from '@/components/MainNav'

export default {
  components: {
    Annotation,
    MainNav,
    MDBBtn,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
    VideoBackground
  },
  computed: {
    pathToLogo () {
      if (plexConfig.accenture) {
        return require('@/assets/img/RA-PLEX-Accenture.png')
      }
      return require('@/assets/img/RA-banner.png')
    },
    pathToWarmer () {
      if (plexConfig.accenture) {
        return 'mp4/RAPlex-Accenture_Screen Warmer.mp4'
      }
      return 'mp4/RAPlex_Screen Warmer.mp4'
    },
    plexConfig () {
      return plexConfig
    },
    ...mapGetters([
      'getAnnotation',
      'getHotspots',
      'getNavShowing',
      'getShowAnnotation',
      'getZoomId',
      'getZoomState'
    ])
  },
  methods: {
    back () {
    },
    click (id) {
      const hotspot = this.hotspotFor(id)
      const state = this.getZoomState
      if (state === 'in') {
        // open content
        console.log('click to set content: ' + id)
        if (this.getZoomId === id) {
          console.log('-already there')
          return
        }
        this.content(hotspot.id)
        this.setShowAnnotation(true)
      } else if (state === 'out') {
        // zoom in if there is a zoom in the env
        const zoom = id // hotspot.zoom
        if (zoom) {
          // ZOOM IN
          console.log('zoomin')
          this.updateZoom(zoom, 'out')
          if (this.pathToZoom('IN')) {
            this.updateZoom(zoom, 'zoomin')
          } else {
            console.log('zoom missing for ' + id)
            this.updateZoom(zoom, 'in')
          }
        } else {
          // otherwise open content
          this.content(hotspot.id)
        }
      }
    },
    content (id) {
      console.log('setting annotation to ' + id)
      this.setAnnotation(id)
    },
    error () {
      console.log('error')
      this.zoomPlaying = false
    },
    goHome () {
      if (this.getNavShowing === true) {
        this.setNavShowing(false)
      } else if (this.getZoomState === 'out') {
        this.warmer = true
      }
    },
    hotspotFor (id) {
      return this.getHotspots[id]
    },
    isVisible (id) {
      const state = this.getZoomState
      const zoom = this.getZoomId
      const hotspot = this.hotspotFor(id)
      if (state === 'in') {
        if (hotspot.zoom && hotspot.zoom !== zoom) {
          return false
        }
        return true
      }
      if (state === 'out') {
        return true
      }
      return false
    },
    loading () {
      console.log('loading')
    },
    nullOut () {
      this.updateZoom(null, 'out')
    },
    pathTo (dir, zoom) {
      return this.getZoomId + '_' + dir.toUpperCase() + '.mp4'
    },
    pathToZoom (dir = 'IN') {
      const path = this.pathTo(dir, true)
      let zoom = false
      try {
        zoom = require(`@/assets/zooms/${path}`)
      } catch (exception) {
        console.log('can not find zoom: ' + path)
      }
      return zoom
    },
    playing () {
      console.log('playing')
      this.zoomPlaying = true
    },
    position (hotspot) {
      return {
        left: hotspot.envs[0].leftPct + '%',
        top: hotspot.envs[0].topPct + '%'
      }
    },
    updateZoom (id, state, bypassZoom) {
      if (bypassZoom) {
        this.skipZoom = true
      }
      console.log('id: ' + id)
      console.log('state: ' + state)
      this.setZoomId(id)
      this.setZoomState(state)
    },
    zoomEnded () {
      console.log('ended ' + this.getZoomState)
      this.zoomPlaying = false
      if (this.getZoomState === 'zoomin') {
        this.setZoomState('in')
        this.content(this.getZoomId)
      } else {
        this.setZoomState('out')
      }
    },
    zoomOut () {
      // ZOOM OUT
      this.skipZoom = false
      if (this.getZoomState !== 'in') {
        return
      }
      console.log('zoomout')
      if (this.pathToZoom('OUT')) {
        this.setZoomState('zoomout')
      } else {
        console.log('skipping to home')
        this.nullOut()
      }
    },
    ...mapMutations([
      'setAnnotation',
      'setNavShowing',
      'setShowAnnotation',
      'setZoomId',
      'setZoomState'
    ])
  },
  name: 'Environment',
  setup () {
    const i18n = inject('i18n')
    const skipZoom = ref(false)
    const store = useStore()
    const warmer = ref(false)
    const { idle } = useIdle(10 * 60 * 1000) // 10 min
    watch(idle, (idleValue) => {
      warmer.value = idleValue
    })
    watch(() => store.getters.getShowAnnotation, (show, prevShow) => {
      if (!show && store.getters.getAnnotation) {
        // clear annotation in store if close is pressed
        store.commit('setAnnotation', null)
      }
    })
    watch(() => store.getters.getAnnotation, (id, prevId) => {
      // show the content modal if an annotation has been set
      store.commit('setShowAnnotation', id !== null)
    })
    const zoomPlaying = ref(false)
    return { i18n, skipZoom, warmer, zoomPlaying }
  }
}
</script>

<style lang="scss">
.aspectContainer {
  padding-top: 56.25%;
}

.backstop {
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
}

.environment {
  background-size: contain!important;
  background-repeat: no-repeat!important;

  h1 {
    &.main.title {
      font-size: 6rem;
      font-weight: 800;
      line-height: 1.0;
      position: absolute;
      top: 5%;
      left: 7%;
    }
  }

  .back {
    bottom: 1em;
    left: 50%;
    transform: translateX(-50%);
    color: var(--mdb-primary);
    font-size: 1.4rem;
    font-weight: 600;
    text-transform: uppercase;

    &:hover {
      cursor: pointer;
    }
  }

  .home {
    position: absolute;
    right: 1.5rem;
    bottom: 1.5rem;
  }

  .hotspot {
    width: 5%;
    z-index: 200;

    button {
      width: 100%;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .logo {
    position: fixed;
    left: -1%;
    bottom: -2%;
    height: 15vh;
    z-index: 1200;

    &.accenture {
      left: -3%;
    }
  }

  .modal-content {
    background-color: rgba(0, 62, 126, 0.7);
    padding: 2rem 1rem;

    video {
      padding: 1rem 0;
    }

    .btn-close {
      position: absolute;
      top: 0.5rem; right: 0.5rem;
    }
  }

  .modal-header {
    padding-bottom: 0;
  }

  .warmer {
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1500;
  }

  > .row {
    margin: 0;
  }

  > .row > * {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
